import $ from 'jquery';
import { getHeight, getScrollTop, onScroll } from '../utils/window';

export default function footerSection() {

	const $scroller = $('html, body');
    const $footer = $('#footer');
    const $footerArrow = $footer.find('.arrow-button');
    const $body = $('.body');

    function arrowUp() {
        if(!$footerArrow.hasClass('is-up')) {
            $footerArrow.addClass('is-up');
            $footerArrow.off('click');
            
            $footerArrow.click(function(){
                $scroller.animate({ scrollTop: 0 }, { duration: 500 });
            });
        }
    }

    function arrowDown() {
        $footerArrow.removeClass('is-up');
        $footerArrow.off('click');

        $footerArrow.click(function (){
            if($body) {
                $scroller.animate({ scrollTop: $body.offset().top }, { duration: 500 });
            } else {
                $scroller.animate({ scrollTop: $('.barba-container > .content_container').offset().top }, { duration: 500 });
            }
            $footerArrow.off('click');
        });
    }

	function changeArrow() {
        if((getScrollTop() + getHeight()) == $(document).height()) {
            arrowUp()
        }else if(getScrollTop() < getHeight()) {
            arrowDown()
        } else {
            arrowUp()
        }
    }

    $('.hero_content_button').click(function() {
        const _this = this;

        $scroller.animate({ scrollTop: $body.offset().top }, { duration: 500 });
    })
    
    onScroll(changeArrow);
    
    if ($('.our-range').length > 0) {
        $('.footer').addClass('+background-darker');
    } else {
        $('.footer').removeClass('+background-darker');
    }

    if ($('.stockist').length > 0) {
        $('.footer').addClass('footer-stockist');
    } else {
        $('.footer').removeClass('footer-stockist');
    }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/footer.js